export default __webpack_public_path__ + "static/outline-connect-dc3c63e5dafdc7e800a5055c8916dc58.svg";